<template>
  <div id='ae' class='' v-loading='loading'>
    <tyc :tqobj='tqobj'></tyc>

  <el-dialog  class='gDia' :title="$t('app_addPush')" v-model="dialogVisible" size='middle'>
    <div style='width:100%;background:none;text-align:left;' class='gDiaTable'>



      <el-col :span="6">
        <div style='margin-right:16px;'>
          <MechanismSelector style='' :data="mechanismData"></MechanismSelector>
        </div>
      </el-col>
   

      <span>
        <el-select @change='selectChange' style='width:16%;margin-right:10px;' v-model="status" clearable :placeholder="$t('app_status')">
          <el-option
            v-for="item in stModel"
            :key="item.vl"
            :label="item.lb"
            :value="item.vl">
          </el-option>
        </el-select>
      </span>


      <el-input
      :placeholder="$t('app_searchTerminal')"
      icon="search"
      :on-icon-click="srchDevice"
      @keyup.enter.native='srchDevice'
      style='width:40%;margin-bottom:10px;'
      v-model="srchValue">
      </el-input>
    </div>




    <el-table
    :data="tableData"
    v-loading='dLoading'
    border
    tooltip-effect="dark"
    style="width: 100%">
      <el-table-column
        align='center'
        prop="terminalNo"
        :label="$t('app_terNo')"
        width="150">
      </el-table-column>
      <el-table-column
        align='center'
        prop="terminalName"
        :label="$t('app_terName')"
        width="130">
      </el-table-column>
      <el-table-column
        prop="terminal_status"
        align='center'
        :label="$t('app_status')"
        width="90">
        <template slot-scope="scope">
          <span v-if='config.fileType == 6'>
            <el-tag v-if="scope.row.terminalStatus == 1 " type="success" size="mini">{{$t('app_enable')}}</el-tag>
            <el-tag v-if="scope.row.terminalStatus == 0 " type="gray" size="mini">{{$t('app_new')}}</el-tag>
          </span>
          <span v-else>
           
            <tagc :tagobj="{type: 'terSt', vl: scope.row.terminalStatus}"></tagc>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        align='center'
        prop="mechName"
        :label="$t('app_distributor')"
        width=''>
      </el-table-column>
      <el-table-column
        prop="operate"
        :label="$t('app_operate')"
        align='center'
        width='80'>
        <template slot-scope='scope'>
          <!-- <el-button   @click='bindOperate(scope.row)' type=text>{{$t('app_push')}}</el-button> -->
          <el-tooltip class="item" effect="dark" :content="$t('app_push')" placement="top">
            <el-button type='text' @click='bindOperate(scope.row)'><i class="fa fa-upload" style=""></i></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <div class="gPgDiv" style=''>

      <el-pagination
      @current-change="pageSelect"
      @size-change="pageSized"
      :current-page="index"
      :page-sizes='$gRows'
      :page-size="$gRow"
      class='gPg'
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
      </el-pagination>
      <!-- <el-pagination
        small
        layout="prev, pager, next"
        :total="total">
      </el-pagination> -->

    </div>

  </el-dialog>

  <el-dialog class='gDia' :title="$t('app_banReason')" v-model="notPassDialog">
    <el-form :model="form">
      <el-form-item :label="$t('app_reason')" label-width="14%">
        <el-input v-model="reason" ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="notPassDialog = false">{{$t('app_cancel')}}</el-button>
      <el-button type="primary" @click="verifyRqs('3')">{{$t('app_submit')}}</el-button>
    </div>
  </el-dialog>


    <div class='gPageBorder' >
      <div style='width:100%;height:100%;background: none;padding:0 0px 0 24px;'>
        <div style='height:64px;'>
          <button class='ldt-word-main' style='padding:0;height:100%;font-size:22px;background:none;border:none;'>{{config ? config.fileName : ''}}</button>
        </div>
        <div style='height:65px;'>
          <table class='ldt-file'>
            <tr style=''>
              <td>
                <label class='ldt-word-title'>{{$t('app_version')}}：</label>
                <label class='ldt-word-main'>{{config ? config.fileVersion : ''}}</label>
              </td>
              <td>
                <label class='ldt-word-title'>{{$t('app_filetype')}}：</label>
                <label class='ldt-word-main'>{{config ? getftype[config.fileType] : ''}}</label>
              </td>
              <td>
                <label class='ldt-word-title'>{{$t('app_subtype')}}：</label>
                <label class='ldt-word-main'>{{config ? getstype[config.subFileType] : ''}}</label>
              </td>
              <td>
                <label class='ldt-word-title'>{{$t('app_distributor')}}：</label>
                <label class='ldt-word-main'>{{config ? config.mechName : ''}}</label>
              </td>
            </tr>
            <tr style=''>
              <td>
                <label class='ldt-word-title'>{{$t('app_adddate')}}：</label>
                <label class='ldt-word-main'>{{config ? config.createTime : ''}}</label>
              </td>
              <td>
                <label class='ldt-word-title'>{{$t('app_fileSize')}}：</label>
                <label class='ldt-word-main'>{{config ? (config.fileSize/1024).toFixed(2) : ''}}KB</label>
              </td>
              <td colspan="2">
                <label class='ldt-word-title'>MD5：</label>
                <label class='ldt-word-main'>{{config ? config.hashCode : ''}}</label>
              </td>
              <td>
                
              </td>
            </tr>
          </table>
        </div>
        <div style='background:none;min-height:10px;display:flex;display:-webkit-flex;'>
          <div class='ldt-word-title' style='display:inline-block;min-width:70px;'>
            {{$t('app_filedesc')}}：
          </div>
          <div class='ldt-word-main' style='display:inline-block;position:relative;background:none;margin: 0 24px 24px 0;padding-right:24px;'>
            <pre>{{config ? config.memo:''}}</pre>
          </div>
        </div>

        <div style='background:none;padding: 10px 0px 24px 0px;'>
          <el-button @click="$router.go(-1);">{{$t('app_cancel')}}</el-button>
          <el-button @click="verify('2')" type='success'>{{$t('app_psverify')}}</el-button>
          <el-button @click="verify('3')" type='danger'>{{$t('app_ban')}}</el-button>
          <el-button @click="dialogVisible = true;" type='primary' style='margin-left:20px;'>{{$t('app_pushtest')}}</el-button>
          <el-button @click="openlink" type='primary' style='margin-left:4px;'>{{$t('app_downfile')}}</el-button>
        </div>

      </div>
    </div>
     
    <!-- <div class='gPageBorder gTopMg' v-show='captures? captures.length > 0 : false'  style=''>
      
      <p class='gCtColor  gPTitle' style=''>{{'launch' + $t('app_printscreen')}} </p>
      <div>
        <img onerror="this.src='/static/img/df-h.png'" v-for='item in captures' class='gBorder' style='width:180px;height:320px;margin:24px 0 24px 24px;border-radius:4px;' :src="imgFullUrl(item)">
      </div>
  
    </div> -->

    <!-- <div class='gPageBorder gTopMg' v-show='config.type === 2 && config.isHistory' style=''>
      
      <p class='gCtColor gPTitle' style=''>{{$t('app_hisVer')}} </p>

      <el-button  v-show="showUploadNew"  @click='uploadNew' type='primary' style='margin: 24px 0 24px 24px' class=''>{{$t('app_ulNew')}}</el-button>
      
      <el-table
        :data="tableData"
        border
        style="width: 100%;">
        <el-table-column
          header-align='center'
          align='center'
          prop="appName"
          :label="$t('app_appName')"
          width="">
        </el-table-column>
        <el-table-column
          header-align='center'
          align='center'
          prop="appVersion"
          width=''
          :label="$t('app_version')">
        </el-table-column>
        <el-table-column
          header-align='center'
          align='center'
          prop="appCategoryName"
          width=''
          :label="$t('app_type')">
        </el-table-column>
      
        <el-table-column
          header-align='center'
          align='center'
          :formatter="dateFormat"
          prop="createTime"
          width='170'
          :label="$t('app_createTime')">
        </el-table-column>
        <el-table-column
          header-align='center'
          align='center'
          prop=""
          width='80'
          :label="$t('app_operate')">
          <template slot-scope='scope'>
            <el-button v-show="config.data.isoperation === 0" type=text @click='deleteAppHis(scope.row)'>{{$t('app_del')}}</el-button>

            <el-tooltip class="item" effect="dark" :content="$t('app_del')" placement="top">
              <el-button type='text' v-show="config.data.isoperation === 0" @click='deleteAppHis(scope.row)'><i class="fa fa-trash-o" style="color:#FF4949"></i></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div> -->
  

  </div>
</template>

<style>
  .ldt-word-main{color:rgb(72,87,106)}
  .ldt-word-title{color:#99A9BF;}
  pre{
    white-space: pre-wrap;
    word-wrap: break-word;
    white-space: -moz-pre-wrap;
    white-space: -pre-wrap;
    white-space: -o-pre-wrap;
    word-break:break-all;
  }

  .ldt-file{width:calc(100% - 48px);height:100%;background:none;}
    .ldt-file td{width:25%;background:none;}

  /* upload */
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .capture {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width:120px;
    display:inline-block;
  }
  .capture div{float:left;}

  .avatar-uploader .el-upload:hover {
    border-color: #20a0ff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 128px;
    height:128px;
    line-height: 128px;
    text-align: center;
  }

  /* upload */
  .sm-avatar-uploader-icon {
    font-size: 36px;
    color: #8c939d;
    width: 72px;
    height:72px;
    line-height: 72px;
    text-align: center;
  }
  .sm-avatar {
    width: 64px;
    height: 64px;
    display: block;
  }
 
</style>

<script>
  import mm from 'moment'
  import df from '../../../assets/df.png'
  import MechanismSelector from '@/components/global/mechanism_selector.vue'
  import tyc from '@/components/global/tyc.vue'
  import tagc from '@/components/global/tagc'
  export default {
    data () {
      var that = this
      return {
        tqobj: '',
        getftype: '',
        getstype: '',
        dLoading: false,
        srchValue: '',
        reason: '',
        config: '',
        isNon: false,
        captures: [],
        loading: 0,
        dialogVisible: false,
        notPassDialog: false,
        index: 1,
        tableData: [],
        total: 0,
        status: '',
        mech: '',
        stModel: '',
        nmSt: '',
        gunSt: [
          {lb: this.$t('app_new'), vl: '0'},
          {lb: this.$t('app_enable'), vl: '1'},
        ],
        mechanismData: {
          callback (value) {
            that.mech = value
            that.selectChange(value)
          }
        }
      }
    },
    components: {
      MechanismSelector,tyc,tagc
    },
    computed: {
      /*avtStyle () {
        var url = this.config.data.appBigIcon ? this.imgFullUrl(this.config.data.appBigIcon) : require('../../../assets/df.png')
        
        return 'background-size: cover;background-position: center center;width:100%;height:100%;background-image: url(' + url + ')'
      },*/
      showUploadNew () {
        console.log('ccc', this.config.data)
        if (this.config.data) {
          if (this.config.data.isoperation === 0 && this.config.data.appStatus === '2') {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      }
    },
    methods: {
      openlink () {
        window.open(this.$host + this.config.fileUrl)
      },
      bindOperate (row) {
        this.dLoading = 1
        this.$filePushTest(this.config.fileId, row.terminalNo, (res) => {
          this.dLoading = 0
          if (res.status === 200) {
            this.$message.success(this.$t('app_pssuccess'))
            this.notPassDialog = false
          } else {
            this.$message.error(res.message)
          }
        }, (error) => {
          this.dLoading = 0
          this.$message.error(this.$t('app_rqsError'))
        })
      },
      verify (vl) {
        if (vl === '2') {
          // yes
          this.$confirm(this.$t('app_srpassvf') + '?', this.$t('app_tip'), {
            confirmButtonText: this.$t('app_sure'),
            cancelButtonText: this.$t('app_cancel'),
            type: 'warning'
          }).then(() => {
            this.verifyRqs(vl)
          }).catch(() => {
          })
        } else if (vl === '3') {
          // no
          this.notPassDialog = true
        }
      },
      verifyRqs (vl) {
        this.loading = 1
        this.$verifyFile(this.config.fileId, this.reason, vl, (res) => {
          this.loading = 0
          if (res.status === 200) {
            this.$message.success(res.message)
            this.$router.go(-1)
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.$message.error(this.$t('app_rqsError'))
          this.loading = 0
        })
      },
      srchDevice () {
        // this.getDevices()
        this.getCmList()
      },
      selectChange (vl) {
        // this.getDevices()
        this.getCmList()
      },
      pageSelect (index) {
        this.index = index
        // this.getDevices()
        this.getCmList()
      },
      pageSized (val) {
        this.$gRow = val
        // this.getDevices()
        this.getCmList()
      },
      getDevices () {

        var vl = this.srchValue ? this.srchValue : ''
        var channel = this.channelId ? this.channelId : ''
        var status = this.status ? this.status : ''
        var mc = this.mech
        var fileMechId = ''
        var fileType = ''
        var fileId = ''
        this.loading = 1
        this.$canPushTer(this.index, this.$gRow, fileMechId, mc, status, vl, fileType, fileId, (res) => {
          
          this.loading = 0
          if (res.data) {
            this.tableData = res.data
            this.total = res.total
          }
        }, () => {
          // error
          this.loading = 0
        })

      },
      getNonDevices () {

        var vl = this.srchValue ? this.srchValue : ''
        var channel = this.channelId ? this.channelId : ''
        var status = this.status ? this.status : ''
        var mc = this.mech
        this.loading = 1

        this.$getNonItDv(this.index, this.$gRow, mc, vl, status,'','', '','','', (res) => {
          
          this.loading = 0
          if (res.data) {
            this.tableData = res.data
            this.total = res.total
          }
        }, () => {
          // error
          this.loading = 0
        })

      },
      setInstallType (type) {
        return this.$installType[type]
      },
      dateFormat (row, column) {
        var date = row[column.property]
        if (date === undefined) {
          return ''
        }
        return mm(date).format('YYYY-MM-DD hh:mm:ss')
      },
      selectChange (vl) {
        // this.getDevices()
        this.getCmList()
      },
      pageSelect (index) {
        this.index = index
        // this.getDevices()
        this.getCmList()
      },
      pageSized (val) {
        this.$gRow = val
        // this.getDevices()
        this.getCmList()
      },
     


      deleteAppHis (row) {
        // console.log(row)
        if (row.applicationid) {
          this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
            confirmButtonText: this.$t('app_sure'),
            cancelButtonText: this.$t('app_cancel'),
            type: 'warning'
          }).then(() => {
            this.loading = 1
            if (this.$appUrlTag === 0) {
              this.$deleteApp(row.applicationid, (res) => {
                this.loading = 0
                if (res.status === 200) {
                  this.getAppHistory()
                } else {
                  this.$message.error(res.message)
                }
              }, () => {
                // error
                this.loading = 0
              })
            } else {
              this.$deleteAppHis(row.applicationid, (res) => {
                this.loading = 0
                if (res.status === 200) {
                  this.getAppHistory()
                } else {
                  this.$message.error(res.message)
                }
              }, () => {
                // error
                this.loading = 0
              })
            }
          }).catch(() => {
          })
        }
      },
 
      imgFullUrl (path) {
        if (path) {
          // return this.$host + path
          // console.log('imgpath', path, this.$urls.prefix + path)
          return this.$urls.prefix + path
        } else {
          return ''
        }
      },

      getAppHistory () {
        if (!this.config.data.appName) {
          return
        }
        // console.log('pkg', this.config.data)
        this.loading = 1
        if (this.$appUrlTag === 0) {
          this.$getAppHistory(this.config.data.appName, this.config.data.packagename, (res) => {
            
            //alert(res)
            this.loading = 0
            if (res.status === 200) {
              this.tableData = res.data
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            // error
            this.loading = 0
          })
        } else {
          
          this.$getAppHistory1(localStorage.mechanismId, this.config.data.packagename, (res) => {

            this.loading = 0
            if (res.status === 200) {
              this.tableData = res.data
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            // error
            this.loading = 0
          })
        }
        
      },
      uploadNew () {
        // this.config = {type: 4, data: this.config}
        // this.$router.push({name: this.$t('menu.appManageSub.uploadNew')})
      },
      getCmList () {
        switch (this.config.fileType) {
          case '1':
          case '2':
          case '3':
          case '4':
          case '5':
          case '10':
            this.stModel = this.nmSt
            this.getDevices()
            // this.getNonDevices()
            this.isNon = false
            break
          case '6':
            this.stModel = this.gunSt
            this.isNon = true
            this.getNonDevices()
            break
        }
      },
      init () {
        this.config = this.$getWObj().fileDetail
        
        
        this.getCmList()
        
        
      }
      
    },
    mounted () {
      this.tqobj = {
        keys: ['ftype','sftype','terminalTypes'],
        callback: (data) => {
          this.getftype = data[0]
          this.getstype = data[1]
          this.nmSt = data[2]

          this.status = '1'
          this.init()
        }
      }

      
    }
  }
</script>



// WEBPACK FOOTER //
// verify.vue?a5fec94c